// extracted by mini-css-extract-plugin
export default {"confirm":"style_confirm__zSUaq","confirm__button":"style_confirm__button__4xTk6"};